import { PropsWithChildren, useCallback, useState } from 'react';
import { useMutation } from 'react-query';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { useStore } from 'hooks/useRootStore';
import { Switch } from '../Switch/Switch';
import { statusCellTranslations } from './translations';
import { IStatusCellProps, StatusCellTransFields } from './types';
import { StatusTypeReq } from 'types/common';

export const StatusCell = function <T extends StatusTypeReq>({
  id,
  status,
  changeStatus,
  disabled = false,
  openPopUpData,
}: PropsWithChildren<IStatusCellProps<T>>) {
  const {
    alertStore: { showAlert },
    popUpStore: { openPopUp, closePopUp },
  } = useStore();

  const { t } = useMyTranslations<StatusCellTransFields>([statusCellTranslations.name]);

  const [activeStatus, setActiveStatus] = useState(status === 'Active');

  const { mutate, isLoading } = useMutation(changeStatus, {
    mutationKey: 'changeStatus',
    onMutate: () => {
      setActiveStatus((prev) => !prev);
    },
    onSuccess: () => {
      showAlert(t('changeStatusSuccess'), 'success');
      closePopUp();
    },
    onError: () => {
      setActiveStatus((prev) => !prev);
    },
  });

  const onChange = useCallback(() => {
    const data: StatusTypeReq = { id, status: activeStatus ? 'Inactive' : 'Active' };
    if (openPopUpData) {
      const { cbArgs, ...popUpData } = openPopUpData;
      openPopUp({
        ...popUpData,
        cb: (cbData) => {
          console.log('cbData', cbData);
          mutate({ ...data, ...cbData, ...cbArgs } as T);
        },
      });
    } else {
      mutate(data as T);
    }
  }, [id, activeStatus, mutate, changeStatus, openPopUpData, openPopUp]);

  return <Switch isActive={activeStatus} onChange={onChange} disabled={isLoading || disabled} />;
};
